<template>
  <div class="main">
    <div class="body">
      <div class="border">
        <div class="title">学科兴趣</div>
        <div class="txt">
          <p style="text-indent: 2rem; font-weight: bold; margin-top: 20px">
            追求兴趣是人生的内驱力之一，也是生命本身的意义。
          </p>
          <p style="text-indent: 2rem; font-weight: bold">
            对于一门学科，如果对它本身有兴趣，我们的学习效率会很高。对于要上大学选择专业的考生而言，要选择的学科门类很多，自然必须先了解：自己最喜欢哪些学科？这些学科是稳定的还是暂时的？
            从高中生这个年龄阶段来看，兴趣开始逐渐从广泛到狭窄，甚至有些人已经固定，兴趣的稳定性开始增强，大致倾向性已经比较明确。而学习每一种专业都和学生在高中阶段对各门学科的学习情况、对学科的感兴趣情况是相关的。如：生物感兴趣的学生，可能憧憬着学习生物科学、生态学或医学；对语文感兴趣的学生，可能会希望报考中文专业，等等。所以，根据学科兴趣来选择专业就非常重要，而且有较高参考价值。
          </p>
          <div style="font-size: 18px; margin-top: 50px; margin-bottom: 10px">
            学科兴趣指数
          </div>
          <div v-for="(item, keys) in xkpx" :key="keys">
            <div>
              <div style="
                      display: inline-block;
                      width: 20%;
                      text-align: right;
                      padding-right: 25px;
                    ">
                {{ item.Subject }}
              </div>
              <div style="display: inline-block; width: 60%">
                <el-progress :text-inside="true" :stroke-width="20" :format="format1" :percentage="Number(item.Points)"></el-progress>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <!--这里是分页	-->
    <div id="page1" style="page-break-after: always"></div>
    <!--分页结束-->
  </div>
</template>

<script>
export default {
  props: ["xkpx"],
  name: "",
  
  
  methods: {
    doPrint() {
      window.pageYoffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      this.getPdf("#pdfDom");
    },
    format(item) {
      return item / 4;
    },
    format1(item) {
      return item;
    },
  },
};
</script>

<style scoped lang='less'>
.content {
  max-width: 800px;
  margin: 0 auto;
}
.main {
  .home_page {
    background-image: linear-gradient(#8950d5, #bb85e7);
    color: white;
    overflow: hidden;
    margin-bottom: 30px;
  }
  .body {
    padding: 20px;
  }
  .border {
    padding: 20px;
    padding-bottom: 40px;
    border: 1px solid #c4a7e9;
    position: relative;
    margin-top: 57px;
    .title {
      position: absolute;
      top: -23px;
      left: 276px;
      height: 41px;
      width: 200px;
      background: #c4a7e9;
      text-align: center;
      line-height: 40px;
      color: white;
    }
  }

  .tables {
    border: 1px solid #c4a7e9;
  }

  .line div {
    padding: 6px;
    font-weight: bold;
    background-color: #ffffff;
  }
  .l {
    float: left;
  }
  .r {
    float: right;
    margin-bottom: 0px;
  }
}
.n_title {
  display: inline-block;
  text-indent: 2rem;
  position: relative;
  left: -21px;
  background: #c4a7e9;
  color: white;
  margin-top: 90px;
  margin-bottom: 20px;
  width: 300px;
}
.right {
  display: inline-block;
  width: 400px;
  span {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
}
.txt {
  line-height: 30px;
}
#chart {
  width: 500px;
  height: 500px;
  margin: 100px auto 0;
}
.tables1 {
  margin-top: 10px;
  border-collapse: collapse;
  td {
    border: 1px solid rgb(173, 169, 169);
  }
}
.print {
  position: fixed;
  bottom: 100px;
  right: 200px;
}
</style>
